import { render, staticRenderFns } from "./WeChatLogin.vue?vue&type=template&id=7ddfc08e&scoped=true"
import script from "./WeChatLogin.vue?vue&type=script&lang=js"
export * from "./WeChatLogin.vue?vue&type=script&lang=js"
import style0 from "./WeChatLogin.vue?vue&type=style&index=0&id=7ddfc08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddfc08e",
  null
  
)

export default component.exports